module.exports = __webpack_public_path__ + "img/light@2x.85804b46.png";